<div [copoScroller]="{ restoreAfterViewInit: false }" #scroller="copoScroller" class="sidenav-content" @routeAnimation>
	<copo-panel-header class="step-title" [isBackButtonVisible]="true" (backButtonClick)="goBack()" [titleHeaderText]="pageTitle">
		<div *ngIf="isButtonSubmitVisible()">
			<button type="button" mat-flat-button color="primary" (click)="addUser()">
				<span translate>add-user.proceed-to-creation</span>
			</button>
		</div>
		<ng-container *ngIf="!hideNextBtn">
			<button type="submit" mat-flat-button color="primary" (click)="goToNext()">
				<span translate>offers.action.next</span>
			</button>
		</ng-container>
	</copo-panel-header>
	<div class="card-block">
	<copo-stepper [steps]="steps" (stepClicked)="onStepClicked($event)">
	</copo-stepper>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
	<router-outlet *ngIf="!isLoading; else loading" copoAfterViewInit (afterviewinit)="scroller.restoreState()" (activate)="onActivate($event)">
	</router-outlet>
	</div>
</div>